import { ExtractPropTypes, PropType } from "vue";
import { UiTypes } from "@various/constants";

export const UiSelectPropsOption = {
    classExtraName: { type: String } /**候选项类名 */,
    placeholder: { type: String } /**提示文本 */,
    modelValue: { required: true } /**选中项绑定值 */,
    //* 候选项宽度控制
    widthExtra: {
        type: [Number, String] as PropType<number | "auto" | "content">,
        default: "content",
        validator: (value: unknown) => !isNaN(Number(value)) || value == "auto" || value == "content",
    },
    candidates: { type: Array as PropType<UiTypes.candidate[]>, required: true } /**候选项 */,
    clearable: { type: Boolean, default: false }, //* 清空按钮是否显示
    animation: { type: Boolean, default: true }, //* 过渡动画是否开启
    disabled: { type: Boolean, default: false }, //* 选择器是否禁用
    readonly: { type: Boolean, default: false }, //* 选择器是否只读
    loading: { type: Boolean, default: false }, //* 选择器内置加载器是否开启
    resolve: { type: Function as PropType<() => string> }, //* 选择器文本解析控制器
    height: { type: Number, default: 240 },
    zIndex: { type: Number, default: 66 },
    detach: { type: Boolean, default: true }, //* 选择器是否当前文档流
    width: { type: [String, Number] as PropType<number | string>, default: 264 },
    size: { type: String as PropType<UiTypes.size>, default: "default" },
    name: { type: String },
} as const;

export type UiSelectProps = ExtractPropTypes<typeof UiSelectPropsOption>;

export const UiSelectEmits = {
    "update:modelValue": (_ev: any) => true,
    "before-enter": () => true,
    "before-leave": () => true,
    "after-enter": () => true,
    "after-leave": () => true,
    "change": (_ev?: Event) => true,
    "clear": (_ev?: any) => true,
};
